import React, { useEffect } from "react";
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AlunoProvider } from './context/AlunoContext';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // ✅ ESTA LINHA AQUI

const AppContent = () => {
  const { currentUser } = useAuth();

  useEffect(() => {
    axios.get('/verificar-usuarios')
      .then(response => {
        console.log('✅ RESPOSTA DO BACKEND:', response.data);
      })
      .catch(error => {
        console.error('❌ ERRO AO ACESSAR /verificar-usuarios:', error.message);
      });
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <AppRoutes currentUser={currentUser} />
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AlunoProvider>
        <AppContent />
      </AlunoProvider>
    </AuthProvider>
  );
};

export default App;
